// NeoAuth0Provider.js
import { Auth0Provider } from "@auth0/auth0-react";
import { NeoAuth0Context } from "./neoAuth0Context";
import ReactDOM from "react-dom";
import React, { Component } from "react";
import { appConfig } from "../../App";

const onRedirectCallback = (appState, user) => {
  // Check if appState contains a returnTo value
  window.history.replaceState(
      {},
      document.title,
      appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
  window.location.replace(appState && appState.returnTo ? appState.returnTo : window.location.pathname);
};

export const NeoAuth0Provider = ({ children }) => (
  <Auth0Provider
    context={NeoAuth0Context}
    domain={appConfig.AUTH0_DOMAIN}
    clientId={appConfig.NEO_AUTH0_SPA_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin + "/neocuesheet",
      audience: appConfig.AUTH0_AUDIENCE,
      scope: "openid profile email"
    }}
    cacheLocation="localstorage"
    useRefreshTokens
    useCookiesForTransactions
    onRedirectCallback={onRedirectCallback}
  >
    {children}
  </Auth0Provider>
);
